export default function GridPattern() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0"
      style={{
        backgroundImage: `
          linear-gradient(var(--grid-line) 1px, transparent 1px),
          linear-gradient(90deg, var(--grid-line) 1px, transparent 1px)
        `,
        backgroundSize: "60px 60px",
        maskImage:
          "radial-gradient(ellipse at center, #000 30%, transparent 80%)",
        WebkitMaskImage:
          "radial-gradient(ellipse at center, #000 30%, transparent 80%)",
      }}
    />
  );
}